import React from 'react';
import {
    Tabs, Button,
} from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { useSearchParams } from 'react-router-dom';
import { PlansTab } from './Plans/PlansTab';
import { VariablesTab } from './Variables/VariablesTab';
import { TutorialProvider, useTutorial } from './tutorial/TutorialProvider';
import { TAB_KEYS } from './common/constants';
import styles from './common/styles.module.scss';

const { TabPane } = Tabs;

const FinanceEngineV2Content: React.FC = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const { resetTutorial } = useTutorial();

    const activeTab = searchParams.get('tab') || TAB_KEYS.PLANS;

    const handleTabChange = (key: string) => {
        searchParams.set('tab', key);
        setSearchParams(searchParams);
    };

    return (
        <div className={styles.container}>
            <div className={styles.header} id="fev2-header">
                <div className={styles.headerTitle}>
                    <h1>Finance Engine</h1>
                </div>
                <div className={styles.headerActions}>
                    <Button
                        id="fev2-tutorial-btn"
                        type="text"
                        icon={<QuestionCircleOutlined />}
                        onClick={resetTutorial}
                        className={styles.tutorialButton}
                    >
                        Tutorial
                    </Button>
                </div>
            </div>

            <div className={styles.tabsContainer}>
                <Tabs
                    activeKey={activeTab}
                    onChange={handleTabChange}
                    size="large"
                >
                    <TabPane
                        tab={<span id="fev2-tab-plans">Plans</span>}
                        key={TAB_KEYS.PLANS}
                    >
                        <PlansTab />
                    </TabPane>
                    <TabPane
                        tab={<span id="fev2-tab-variables">Variables</span>}
                        key={TAB_KEYS.VARIABLES}
                    >
                        <VariablesTab />
                    </TabPane>
                </Tabs>
            </div>
        </div>
    );
};

const FinanceEngineV2: React.FC = () => (
    <TutorialProvider>
        <FinanceEngineV2Content />
    </TutorialProvider>
);

export { FinanceEngineV2 };
